import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import TextField from '../TextField';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import FilterLabel from './FilterLabel';
import { filterPropTypes } from '../../../../utility/prop_types/CriteriaPropType';

/* The Date Pickers actually hold an internal state of what the text field is. If the value of date picker is a
* invalid date then it falls back on the last state of this textfield, overall there is work around with the
* exception that clearing a character in a fully completed date will clear the full date */

const dateFns = new DateFnsUtils();

function DateFilter ({ tree, field, onChange, onClear }) {
    const classes = useStyles();

    function getOperatorValue (min, max) {
        if (Boolean(min) && Boolean(max)) {
            return 'between';
        } else if (min) {
            return 'after';
        } else if (max) {
            return 'before';
        } else {
            return '';
        }
    }

    function handleDate0Change (date) {
        const value = (!isNaN(date) && date != null) ? dateFns.format(date, (field.settings && field.settings.format) || 'yyyy-MM-dd') : null;
        const operator = getOperatorValue(value, tree.properties.value1);

        if (operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            // Only save a valid date to the tree
            newTree.properties = {
                ...newTree.properties,
                value0: value,
                operator: operator
            };
            onChange(newTree);
        }
    }

    function handleDate1Change (date) {
        const value = (!isNaN(date) && date != null) ? dateFns.format(date, (field.settings && field.settings.format) || 'yyyy-MM-dd') : null;
        const operator = getOperatorValue(tree.properties.value0, value);

        if (operator === '') {
            onClear(tree.id);
        } else {
            const newTree = { ...tree };
            // Only save a valid date to the tree
            newTree.properties = {
                ...newTree.properties,
                value1: value,
                operator: operator
            };
            onChange(newTree);
        }
    }

    function renderTextFieldComponent (props) {
        return (
            <TextField
                type="text"
                classes={{ root: classes.textField }}
                {...props}
                // error={props.error || error from backend}
                helperText={undefined} // No helper text yet, breaks styling
                variant="outlined" // Ensure it always is outlined
            />
        );
    }

    const { properties } = tree;
    const { settings } = field;
    const format = (settings && settings.format) || 'yyyy-MM-dd';
    const mask = format.replace(/[yMd]/g, '_');

    return (
        <div className={classes.root}>
            <FilterLabel field={field} />
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    name="value0"
                    disableToolbar
                    autoOk
                    placeholder={(settings && settings.afterPlaceholder) || '1995-01-01'}
                    TextFieldComponent={renderTextFieldComponent}
                    onChange={handleDate0Change}
                    value={(properties.value0 != null && properties.value0 !== '') ? properties.value0 : null}
                    mask={mask}
                    format={format}
                    KeyboardButtonProps={{ size: 'small' }}
                    InputAdornmentProps={{ classes: { positionEnd: classes.inputAdornmentPositionEnd } }}
                />
                <KeyboardDatePicker
                    name="value1"
                    disableToolbar
                    autoOk
                    placeholder={(settings && settings.beforePlaceholder) || dateFns.format(new Date(), format)}
                    TextFieldComponent={renderTextFieldComponent}
                    onChange={handleDate1Change}
                    value={(properties.value1 != null && properties.value1 !== '') ? properties.value1 : null}
                    mask={mask}
                    format={format}
                    KeyboardButtonProps={{ size: 'small' }}
                    InputAdornmentProps={{ classes: { positionEnd: classes.inputAdornmentPositionEnd } }}
                />
            </MuiPickersUtilsProvider>
        </div>
    );
}

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        '&> *:not(:last-child)': {
            marginRight: 10,
        },
        '&> div': {
            flexGrow: 1
        }
    },
    textField: {
        width: 150
    },
    inputAdornmentPositionEnd: {
        marginLeft: 0
    }
}));

DateFilter.propTypes = filterPropTypes;

export default DateFilter;